import { Popover } from "antd";
import React from "react";
import { EXPERIENCES } from "../experiencesConstants";

function ExperienceTable({ date, people, price, language, request }) {
  return (
    <div>
      <div className="ahp-reservation-content">
        <div className="ahp-reservation-row">
          <div className="ahp-reservation-label">Data</div>
          <div className="ahp-reservation-value">{date}</div>
        </div>
        <div className="ahp-reservation-row">
          <div className="ahp-reservation-label">Pessoas</div>
          <div className="ahp-reservation-value">{people}</div>
        </div>
        <div className="ahp-reservation-row">
          <div className="ahp-reservation-label">Preço</div>
          <div className="ahp-reservation-value">{price} €</div>
        </div>
        <div className="ahp-reservation-row">
          <div className="ahp-reservation-label">Língua</div>
          <div className="ahp-reservation-value">
            {EXPERIENCES.LANGUAGES_OBJ[language]}
          </div>
        </div>
        {request && (
          <div className="ahp-reservation-notes">
            <Popover
              content={
                <div>
                  <p>{request}</p>
                </div>
              }
              title="Notas"
              trigger="click"
            >
              <a role="button" tabindex="0">
                Notas
              </a>
            </Popover>
          </div>
        )}
      </div>
    </div>
  );
}

export default ExperienceTable;
